import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import 'babel-polyfill'
import axios from 'axios'
import VueAxios from 'vue-axios'
import MaterialIcons from 'material-design-icons/iconfont/material-icons.css'
import VueQRCodeComponent from 'vue-qrcode-component'
import Notifications from 'vue-notification'
Vue.use(Notifications);
Vue.use(require('vue-moment'));
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.component('qr-code', VueQRCodeComponent);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
